// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueI18n  from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
// import i18n from './i18n.js'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
// Vue.prototype.url ='http://uat-wwwapi.fonedoor.com';
Vue.prototype.url ='http://wwwapi.fonedoor.com';
// Vue.prototype.url ='http://wwwapi.fonedoor.com';
// Vue.prototype.url ='http://192.168.10.143:91';
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});
//使用图片懒加载
Vue.use(VueLazyload, {
  error: 'dist/error.png',
  loading: 'dist/loading.gif',// 懒加载使用的图片
})

Vue.use(VueI18n) // 通过插件的形式挂载，通过全局方法 Vue.use() 使用插件
const i18n = new VueI18n({
  locale: 'CN', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    /* 'CN': require('./assets/lang/cn'),
    'EN': require('./assets/lang/en') */
  }
})
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js